import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{attrs:{"src":require("@/assets/images/mk-logo.png"),"max-width":"154"}})
}
var staticRenderFns = []

export { render, staticRenderFns }